var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],attrs:{"id":"loading"}},[_c('div',{staticClass:"loading-inner"},[_c('go-loading-b',{staticClass:"loading",attrs:{"size":24}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }